<loading-overlay [isLoading]="isLoading > 0"></loading-overlay>
<main>
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'Assets_Details' | translate }}
        </h1>
      </div>
    </div>

    <p-panel>
      <p-card data-variant="compact">
        <p-tabs value="0">
          <p-tablist>
            <p-tab value="0">
              {{ 'Assets_Details_Tabs.Categories' | translate }}
            </p-tab>
            <p-tab value="1">
              {{ 'Assets_Details_Tabs.Types' | translate }}
            </p-tab>
            <p-tab value="2">
              {{ 'Assets_Details_Tabs.Models' | translate }}
            </p-tab>
            <p-tab value="3">
              {{ 'Assets_Details_Tabs.ModelProperties' | translate }}
            </p-tab>
          </p-tablist>
          <p-tabpanels>
            <!-- Panel de Categorías -->
            <p-tabpanel value="0">
              <p-panel [header]="'Assets_Details_Tabs.Categories' | translate">
                <ng-template pTemplate="icons">
                  <div class="row-sm-start-center">
                    <p-iconfield>
                      <p-inputicon styleClass="pi pi-search" />
                      <input
                        pInputText
                        #searchCategoryInput
                        type="text"
                        (input)="searchCategory(searchCategoryInput.value)"
                        [placeholder]="'Assets_Details_Tabs.Categories_Input' | translate"
                      />
                    </p-iconfield>
                    <p-button [label]="'Add' | translate" icon="pi pi-plus" variant="outlined" (click)="openCategoryDetailsModal()" />
                  </div>
                </ng-template>
                <p-card data-variant="compact">
                  <ul class="cs-pattern">
                    <li *ngFor="let category of filteredCategories; let i = index" [ngClass]="{ 'container-list__item--green': i % 2 === 0 }">
                      <div>
                        <p>{{ category.name }}</p>
                      </div>
                      <div class="actions">
                        <p-button icon="pi pi-pencil" variant="text" (click)="openCategoryDetailsModal(category)" />
                      </div>
                    </li>
                  </ul>
                </p-card>
              </p-panel>
            </p-tabpanel>

            <!-- Panel de Tipos -->
            <p-tabpanel value="1">
              <p-panel [header]="'Assets_Details_Tabs.Types' | translate">
                <ng-template pTemplate="icons">
                  <div class="row-sm-start-center">
                    <p-iconfield>
                      <p-inputicon styleClass="pi pi-search" />
                      <input pInputText #searchTypeInput type="text" (input)="searchType(searchTypeInput.value)" [placeholder]="'Assets_Details_Tabs.Types_Input' | translate" />
                    </p-iconfield>
                    <p-button [label]="'Add' | translate" icon="pi pi-plus" variant="outlined" (click)="openTypeDetailsModal()" />
                  </div>
                </ng-template>
                <p-card data-variant="compact">
                  <ul class="cs-pattern">
                    <li *ngFor="let type of filteredTypes; let i = index" [ngClass]="{ 'container-list__item--green': i % 2 === 0 }">
                      <div>
                        <p>{{ type.name }}</p>
                      </div>
                      <div class="actions">
                        <p-button icon="pi pi-pencil" variant="text" (click)="openTypeDetailsModal(type)" />
                        <p-button icon="pi pi-wrench" variant="text" (click)="openTypeDetailsProcessModal(type)" />
                      </div>
                    </li>
                  </ul>
                </p-card>
              </p-panel>
            </p-tabpanel>

            <!-- Panel de Modelos -->
            <p-tabpanel value="2">
              <p-panel [header]="'Assets_Details_Tabs.Models' | translate">
                <ng-template pTemplate="icons">
                  <div class="row-sm-start-center">
                    <p-iconfield>
                      <p-inputicon styleClass="pi pi-search" />
                      <input
                        pInputText
                        #searchModelInput
                        type="text"
                        (input)="searchModel(searchModelInput.value)"
                        [placeholder]="'Assets_Details_Tabs.Models_Input' | translate"
                      />
                    </p-iconfield>
                    <p-button [label]="'Add' | translate" icon="pi pi-plus" variant="outlined" (click)="openModelDetailsModal()" />
                  </div>
                </ng-template>
                <p-card data-variant="compact">
                  <ul class="cs-pattern">
                    <li *ngFor="let model of filteredModels; let i = index" [ngClass]="{ 'container-list__item--green': i % 2 === 0 }">
                      <div>
                        <p>{{ model.name }}</p>
                      </div>
                      <div class="actions">
                        <p-button icon="pi pi-pencil" variant="text" (click)="openModelDetailsModal(model)" />
                      </div>
                    </li>
                  </ul>
                </p-card>
              </p-panel>
            </p-tabpanel>

            <!-- Panel de Propiedades del Modelo -->
            <p-tabpanel value="3">
              <p-panel [header]="'Assets_Details_Tabs.ModelProperties' | translate">
                <ng-template pTemplate="icons">
                  <div class="row-sm-start-center">
                    <p-iconfield>
                      <p-inputicon styleClass="pi pi-search" />
                      <input
                        pInputText
                        #searchModelPropertyInput
                        type="text"
                        (input)="searchModelProperty(searchModelPropertyInput.value)"
                        [placeholder]="'Assets_Details_Tabs.ModelProperties_Input' | translate"
                      />
                    </p-iconfield>
                    <p-button [label]="'Add' | translate" icon="pi pi-plus" variant="outlined" (click)="openModelPropertiesModal()" />
                  </div>
                </ng-template>
                <p-card data-variant="compact" class="section-details">
                  <ul class="cs-pattern">
                    <li *ngFor="let model of filteredModelProperties; let i = index" [ngClass]="{ 'container-list__item--green': i % 2 === 0 }">
                      <div>
                        <p>{{ model.name }}</p>
                      </div>
                      <div class="actions">
                        <p-button icon="pi pi-pencil" variant="text" (click)="openModelPropertiesModal(model)" />
                      </div>
                    </li>
                  </ul>
                </p-card>
              </p-panel>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </p-card>
    </p-panel>
  </div>
</main>
